import { TypedDocumentString } from '@haaretz/s-fragments/structures';
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { fetch } from '@haaretz/s-graphql-fetcher';
export const CheckEmailExistPersonalQueryDocument = new TypedDocumentString(`
    query CheckEmailExistPersonalQuery($email: String!, $site: Site!) {
  user: userLogin(email: $email) {
    ssoId: _id
    mobilePhone
    isPaying(site: $site)
    termsCheck(site: $site)
    userStatus {
      ...UserStatusFragment
    }
  }
}
    fragment UserStatusFragment on UserStatus {
  __typename
  isMailValidated
  isMobileValidated
  miniRegStatus
  isPhoneEmailConn
}`);
export const useCheckEmailExistPersonalQuery = (variables, options)=>{
    return useQuery({
        queryKey: [
            'CheckEmailExistPersonalQuery',
            variables
        ],
        queryFn: fetch(CheckEmailExistPersonalQueryDocument, variables),
        ...options
    });
};
useCheckEmailExistPersonalQuery.document = CheckEmailExistPersonalQueryDocument;
useCheckEmailExistPersonalQuery.getKey = (variables)=>[
        'CheckEmailExistPersonalQuery',
        variables
    ];
export const useSuspenseCheckEmailExistPersonalQuery = (variables, options)=>{
    return useSuspenseQuery({
        queryKey: [
            'CheckEmailExistPersonalQuery',
            variables
        ],
        queryFn: fetch(CheckEmailExistPersonalQueryDocument, variables),
        ...options
    });
};
useSuspenseCheckEmailExistPersonalQuery.document = CheckEmailExistPersonalQueryDocument;
useSuspenseCheckEmailExistPersonalQuery.getKey = (variables)=>[
        'CheckEmailExistPersonalQuery',
        variables
    ];
export const useInfiniteCheckEmailExistPersonalQuery = (variables, options)=>{
    return useInfiniteQuery((()=>{
        const { queryKey: optionsQueryKey, ...restOptions } = options;
        return {
            queryKey: optionsQueryKey ?? [
                'CheckEmailExistPersonalQuery.infinite',
                variables
            ],
            queryFn: (metaData)=>fetch(CheckEmailExistPersonalQueryDocument, {
                    ...variables,
                    ...metaData.pageParam ?? {}
                })(),
            ...restOptions
        };
    })());
};
useInfiniteCheckEmailExistPersonalQuery.getKey = (variables)=>[
        'CheckEmailExistPersonalQuery.infinite',
        variables
    ];
export const useSuspenseInfiniteCheckEmailExistPersonalQuery = (variables, options)=>{
    return useSuspenseInfiniteQuery((()=>{
        const { queryKey: optionsQueryKey, ...restOptions } = options;
        return {
            queryKey: optionsQueryKey ?? [
                'CheckEmailExistPersonalQuery.infinite',
                variables
            ],
            queryFn: (metaData)=>fetch(CheckEmailExistPersonalQueryDocument, {
                    ...variables,
                    ...metaData.pageParam ?? {}
                })(),
            ...restOptions
        };
    })());
};
useSuspenseInfiniteCheckEmailExistPersonalQuery.getKey = (variables)=>[
        'CheckEmailExistPersonalQuery.infinite',
        variables
    ];
useCheckEmailExistPersonalQuery.fetcher = (variables, options)=>fetch(CheckEmailExistPersonalQueryDocument, variables, options);

//# sourceMappingURL=CheckEmailExist.js.map